import { put, get } from './base/index';

const clienteApi = {
  get: (id) => get(`/usuario/${id}`),
  update: (userId, form) => put(`/usuario/${userId}`, form),
  changePassword: (id, form) => put(`/cliente/change-password/${id}`, form),
};

export default clienteApi;
